
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11654',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11654",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.450",
  "dashboard-client-types": "static-1.252",
  "data-fetching-client": "static-1.9508",
  "foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-components-legacy": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-theming": "static-1.4241",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7837",
  "hub-http-shared-msw-handlers": "static-1.9551",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11271",
  "I18n": "static-7.1580",
  "jasmine-runner": "static-1.6302",
  "marketplace-storefront-base": "static-1.11714",
  "quartz": "static-1.6774",
  "react-dlb": "static-1.73",
  "react-rhumb": "static-1.16482",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2694",
  "reporting-testing-lib": "static-1.8589",
  "settings-ui-lib": "static-1.12354",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6792",
  "ui-addon-i18n": "static-1.10975",
  "ui-addon-react-router-dom": "static-1.9376",
  "unified-auth": "static-1.258",
  "unified-auth-core-lib": "static-1.539",
  "usage-tracker": "static-1.7166",
  "usage-tracker-core": "static-1.7016",
  "customer-data-property-utils": "static-1.7910",
  "history": "static-4.47",
  "hub-http": "static-1.6050",
  "integrations-lib": "static-1.15531",
  "marketplace-ui-common": "static-1.19038",
  "property-management-iframe": "static-1.12463",
  "quartz-config": "static-1.552",
  "quartz-core": "static-1.5993",
  "quartz-routing": "static-1.204",
  "quick-fetch": "static-1.3767",
  "react": "static-7.180",
  "rpc-client-utils": "static-1.4466",
  "ts-schema": "static-1.3935",
  "ui-universal-auth": "static-1.8744",
  "UIComponents": "static-3.8218",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3258",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3051",
  "quartz-webpack": "static-1.2998",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4668",
  "foundations-theming-specialty": "static-1.1957",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9257",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5204",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1302",
  "ui-fonts": "static-1.533",
  "ui-images": "static-2.1105",
  "bend-plugin-foundations-theming": "static-1.2724",
  "foundations-theming-base": "static-1.3226",
  "stylex": "static-1.28",
  "HeadJS": "static-2.718",
  "hs-test-utils-bend-plugin": "static-1.2948",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4157",
  "ai-components-ui-library": "static-1.8437",
  "ai-rendering-library": "static-1.9398",
  "chirp-fetch": "static-1.1713",
  "connections-embed-lib": "static-1.683",
  "copilot-toolkit": "static-1.10615",
  "laboratory-lib": "static-3.6990",
  "marketplace-embed": "static-1.21560",
  "marketplace-ui-details": "static-1.8934",
  "marketplace-ui-reviews": "static-1.18994",
  "marketplace-ui-tracking": "static-1.13209",
  "sanitize-text": "static-1.7976",
  "ui-addon-video-player": "static-1.8527",
  "usage-tracker-multi": "static-1.5580",
  "usage-tracker-session-replay": "static-1.4852",
  "wootric-nps": "static-1.6815",
  "apollo-link-hub-http": "static-2.4482",
  "immer": "static-1.33",
  "immerable": "static-1.3985",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66656",
  "cssUtils": "static-1.744",
  "flux-actions": "static-1.311",
  "HubStyle": "static-2.11579",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10042",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10204",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7156",
  "icons": "static-2.625",
  "marketplace-ui-apps-core": "static-1.17571",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4351",
  "foundations-components-test-utils": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "quartz-i18n": "static-1.449",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3562",
  "customer-data-objects": "static-1.7479",
  "property-translator": "static-1.5240",
  "frontend-preferences-client": "static-1.7755",
  "hs-promise-utils": "static-1.5424",
  "hubspot-apollo-client": "static-1.4711",
  "integrations-error-boundary-lib": "static-1.12946",
  "integrations-tracking-lib": "static-1.5419",
  "native-integrations-shared-strings": "static-1.7619",
  "reselect": "static-2.16",
  "sanitize": "static-1.4305",
  "superstore": "static-1.4602",
  "ui-shepherd-react": "static-3.9977",
  "ai-settings-ui-library": "static-1.7548",
  "hub-http-janus": "static-1.803",
  "hubspotter-http": "static-1.4508",
  "immutable-less": "static-1.4485",
  "marketplace-ui-client-types": "static-1.16445",
  "nav-meta": "static-1.29016",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10069",
  "ui-addon-upgrades": "static-9.17700",
  "inbound-db-properties-service-client": "static-1.3704",
  "property-management-common": "static-1.4750",
  "ui-addon-iframeable": "static-1.8877",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.491",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.449",
  "quartz-head": "static-1.439",
  "quartz-test": "static-1.449",
  "quartz-tracking": "static-1.153",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2970",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20467",
  "ContentUtils": "static-1.67714",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2320",
  "customer-data-filters-ui": "static-1.39018",
  "customer-data-objects-ui-components": "static-1.12841",
  "customer-data-reference-ui-components": "static-1.12977",
  "embedded-academy-lib": "static-1.13656",
  "ExportDialog": "static-6.10218",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40736",
  "reporting-snowflake": "static-1.55274",
  "reporting-ui-components": "static-2.63927",
  "reporting-visualizations": "static-1.58732",
  "ui-addon-teams": "static-1.21281",
  "magpie-lib": "static-1.5425",
  "magpie-types": "static-1.4885",
  "simple-logging-lib": "static-1.2881",
  "navigation-components": "static-1.17379",
  "ai-studio-lib": "static-1.11086",
  "developer-experience-shared-components": "static-1.10323",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7822",
  "ui-tool-access": "static-1.9976",
  "usage-based-billing-components-lib": "static-1.8095",
  "usage-tracker-anonymous": "static-1.5583",
  "usage-tracker-public": "static-1.6977",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3450",
  "persist-promise": "static-1.3539",
  "reference-resolvers": "static-1.7993",
  "ui-extensibility-client-types": "static-1.3775",
  "hubspot-apollo-cache": "static-1.170",
  "universal-page-editor-lib": "static-1.2830",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2273",
  "merchandise-lib": "static-1.260",
  "atom": "static-1.4901",
  "purchase-motions-components": "static-1.5521",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1382",
  "crm-component-utils": "static-1.38557",
  "crm-properties-common-lib": "static-1.5703",
  "customer-data-properties": "static-1.50862",
  "framework-data-schema-resolvers": "static-1.6703",
  "reference-resolvers-lite": "static-1.7923",
  "navigation-messaging": "static-1.6706",
  "hubspotter-http-shared-msw-handlers": "static-1.9549",
  "cms-field-types": "static-1.4638",
  "content-icons-ui": "static-1.2167",
  "conversations-skeleton-state": "static-1.7079",
  "crm-message-bus": "static-1.42463",
  "customer-data-filters-ui-msw-helpers": "static-1.21453",
  "customer-data-ui-utilities": "static-1.9654",
  "FormUrlGenerator": "static-2.4557",
  "framework-builder-read-service-client": "static-1.3863",
  "framework-data-schema-quick-fetch": "static-1.6608",
  "multi-account-reference-resolvers": "static-1.804",
  "onboarding-tours": "static-1.16306",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13156",
  "academy-common-lib": "static-1.13116",
  "content-assistance-lib": "static-1.7494",
  "dashboard-lib": "static-1.80758",
  "file-manager-components": "static-1.22992",
  "getting-started-shared-tasks": "static-1.17976",
  "hubspot-prosemirror": "static-1.17693",
  "hubspot-prosemirror-plugins": "static-1.17685",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19525",
  "share-with-third-party-component-lib": "static-1.8524",
  "ui-addon-draggable": "static-3.4597",
  "ui-asset-management-lib": "static-1.10748",
  "ui-business-units-lib": "static-1.8860",
  "user-context": "static-1.4930",
  "growth-payments-core": "static-1.24822",
  "reporting-plugins": "static-1.10022",
  "reporting-reports": "static-1.66334",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.556",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28926",
  "react-codemirror": "static-1.10457",
  "apps-service-types": "static-1.3708",
  "oauth-service-types": "static-1.4077",
  "onboarding-scopes": "static-1.6294",
  "onboarding-tours-client": "static-1.4520",
  "platform-infra-nav-components": "static-1.7521",
  "subscription-experience-data-types": "static-1.14621",
  "crm-record-cards-service-types": "static-1.3473",
  "location-customization-utils-lib": "static-1.8665",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4329",
  "nav-client-types": "static-1.2188",
  "purchase-motions-api": "static-1.5524",
  "signup-constants": "static-1.18486",
  "signup-ui-url-generator": "static-2.7865",
  "trials-service-types": "static-1.3730",
  "card-properties-lib": "static-1.43618",
  "commerce-subscription-lib": "static-1.36549",
  "crm-actions": "static-1.6136",
  "crm-cards-data": "static-1.1283",
  "crm-cards-sdk": "static-1.43019",
  "customer-data-properties-shared-msw-handlers": "static-1.8878",
  "customer-data-tracking": "static-1.6713",
  "calling-global-api": "static-1.63791",
  "calling-internal-common": "static-1.31126",
  "calling-lifecycle-internal": "static-1.65173",
  "calling-lifecycle-messages": "static-1.57467",
  "commerce-products-lib": "static-1.8946",
  "conditional-properties-service-client": "static-1.3653",
  "crm-links": "static-1.6097",
  "external-options-client-types": "static-1.4014",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.511",
  "inbounddb-objects-service-types": "static-1.4078",
  "meetings-icalendar-utils-lib": "static-1.463",
  "multi-currency-client-types": "static-1.3546",
  "object-builder-ui-client": "static-1.48108",
  "pipeline-validation-client-types": "static-1.3819",
  "property-value-citations": "static-1.1476",
  "pulse": "static-1.347",
  "smart-property-lib": "static-1.6058",
  "tiered-pricing": "static-1.873",
  "ui-addon-form-validation": "static-1.10825",
  "crm-pipelines-api-client-types": "static-1.3995",
  "react-dnd-compat": "static-1.4451",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5189",
  "growth-onboarding-confetti": "static-1.2903",
  "growth-onboarding-next-action-utils": "static-1.1380",
  "onboarding-tours-utils": "static-1.372",
  "ui-shepherd-tracker": "static-1.7358",
  "academy-service-client": "static-1.3510",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28032",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8216",
  "video-components-external": "static-1.10668",
  "video-data-lib": "static-1.34326",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8398",
  "payment-link-components": "static-1.23028",
  "ui-addon-emoji-picker": "static-1.9718",
  "EmailSignatureEditor": "static-1.23979",
  "viral-links-lib": "static-1.6868",
  "data-token-picker": "static-1.16098",
  "FileManagerLib": "static-1.38632",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5075",
  "getting-started-shared-tasks-store": "static-1.17094",
  "campaign-roi-lib": "static-1.8381",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.223",
  "eligibility-engine-service-types": "static-1.3011",
  "crm_data": "static-4.91347",
  "customer-data-sidebar": "static-2.45504",
  "enrichment-properties-lib": "static-1.15176",
  "commerce-billing-lib": "static-1.18585",
  "commerce-shared-components-lib": "static-1.18032",
  "commerce-tools-ui-lib": "static-1.9876",
  "crm-fe-perf": "static-1.22736",
  "calling-error-reporting": "static-1.31132",
  "shared-worker-versioning": "static-1.10870",
  "calling-usage-tracker": "static-1.6372",
  "voice-sms-access-library": "static-1.341",
  "commerce-permissions": "static-1.590",
  "products-iframe-lib": "static-1.7417",
  "products-ui-components-shared-msw-handlers": "static-1.9933",
  "directed-graph": "static-1.770",
  "event-emitter": "static-1.778",
  "breeze-intelligence-kit": "static-1.5368",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9634",
  "policy-lib": "static-1.6607",
  "react-tinymce": "static-1.54710",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9697",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53836",
  "tinymce-plugins": "static-1.56950",
  "tinymce-themes": "static-1.55806",
  "growth-onboarding-next-action-components": "static-1.1408",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6413",
  "content-media-composition-data-lib": "static-1.11570",
  "content-media-compositions": "static-2.15577",
  "media-bridge-lib": "static-1.18620",
  "commerce-tours-lib": "static-1.5763",
  "growth-onboarding-reliability": "static-1.4917",
  "sales-checkout-service-client": "static-1.3498",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21361",
  "sales-email-signature-service-client": "static-1.3674",
  "audio-components": "static-1.5658",
  "FileManagerCore": "static-1.38491",
  "FileManagerImages": "static-1.36143",
  "video-components": "static-1.12671",
  "crm_universal": "static-1.21715",
  "customer-data-email": "static-1.17724",
  "card-payment-highlight-lib": "static-1.36602",
  "card-subscription-highlight-lib": "static-1.38972",
  "commerce-contract-lib": "static-1.11316",
  "customer-data-content": "static-1.26928",
  "invoices-highlight-card-lib": "static-1.54133",
  "orders-highlight-card-lib": "static-1.20948",
  "products-highlight-card-lib": "static-1.17230",
  "project-storage": "static-1.4564",
  "quotes-highlight-card-lib": "static-1.71312",
  "crm-source-interpretation-lib": "static-1.5160",
  "utility-belt": "static-1.2371",
  "customer-data-associations": "static-1.7169",
  "framework-data-table": "static-2.11490",
  "payments-enrollment-embed-lib": "static-1.22113",
  "customer-data-rte": "static-1.32522",
  "cv-backend-services": "static-1.1514",
  "growth-onboarding-empty-states": "static-1.5413",
  "InboxConnectUtils": "static-4.14307",
  "payments-post-enroll-local-storage-lib": "static-1.4945",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37401",
  "calling-orchestration-schema": "static-1.35118",
  "sales-views-client-types": "static-1.4117",
  "hub-http-contrib": "static-1.2874",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39921",
  "ui-addon-sales-email": "static-1.5045",
  "layout-dnd-components": "static-1.12095",
  "layout-dnd-utils": "static-1.11070",
  "ui-brand-identity-lib": "static-1.14092",
  "NamespacedHubStyle": "static-2.8926",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4362",
  "video-embed": "static-1.35160",
  "social-insights-client-types": "static-1.21453",
  "sequences-lib": "static-1.7737",
  "ui-gdpr-components": "static-1.10178",
  "products-ui-components": "static-1.39465",
  "quotes-ui-lib": "static-1.80032",
  "SalesContentIndexUI": "static-3.8945",
  "accounting-integrations-ui-components": "static-1.6775",
  "invoices-ui-lib": "static-1.54149",
  "commerce-products-api": "static-1.1999",
  "SafeStorage": "static-1.4234",
  "invoices-iframe-lib": "static-1.56207",
  "quotes-modal-lib": "static-1.101989",
  "deal-intel-decorators": "static-1.1373",
  "tanstack-virtual": "static-1.26",
  "stripe-embedded-components": "static-1.7188",
  "draft-content-plugins": "static-1.27789",
  "ContentData": "static-1.67789",
  "layout-data-lib": "static-1.9395",
  "outpost": "static-1.4033",
  "sequences-client-types-lib": "static-1.7594",
  "commerce-tax-lib": "static-1.347",
  "property-description-translator": "static-1.3686",
  "FireAlarmUi": "static-1.4362",
  "sales-templates-service-types-lib": "static-1.4022",
  "commerce-analytics-service-client": "static-1.3486",
  "totals-ui-components": "static-1.23078",
  "deal-intel-utils": "static-1.1377",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14863",
  "advanced-menus-lib": "static-1.11834",
  "ui-memberships-settings-lib": "static-1.33539",
  "commerce-totals-service-types": "static-1.3670",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14862",
  "simple-menus-lib": "static-1.16379"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11654",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.450",
  "dashboard-client-types": "/dashboard-client-types/static-1.252",
  "data-fetching-client": "/data-fetching-client/static-1.9508",
  "foundations-components": "/foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-theming": "/foundations-theming/static-1.4241",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7837",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9551",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11271",
  "I18n": "/I18n/static-7.1580",
  "jasmine-runner": "/jasmine-runner/static-1.6302",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11714",
  "quartz": "/quartz/static-1.6774",
  "react-dlb": "/react-dlb/static-1.73",
  "react-rhumb": "/react-rhumb/static-1.16482",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2694",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8589",
  "settings-ui-lib": "/settings-ui-lib/static-1.12354",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6792",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10975",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9376",
  "unified-auth": "/unified-auth/static-1.258",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.539",
  "usage-tracker": "/usage-tracker/static-1.7166",
  "usage-tracker-core": "/usage-tracker-core/static-1.7016",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7910",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6050",
  "integrations-lib": "/integrations-lib/static-1.15531",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19038",
  "property-management-iframe": "/property-management-iframe/static-1.12463",
  "quartz-config": "/quartz-config/static-1.552",
  "quartz-core": "/quartz-core/static-1.5993",
  "quartz-routing": "/quartz-routing/static-1.204",
  "quick-fetch": "/quick-fetch/static-1.3767",
  "react": "/react/static-7.180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4466",
  "ts-schema": "/ts-schema/static-1.3935",
  "ui-universal-auth": "/ui-universal-auth/static-1.8744",
  "UIComponents": "/UIComponents/static-3.8218",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3258",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3051",
  "quartz-webpack": "/quartz-webpack/static-1.2998",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4668",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1957",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9257",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5204",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1302",
  "ui-fonts": "/ui-fonts/static-1.533",
  "ui-images": "/ui-images/static-2.1105",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2724",
  "foundations-theming-base": "/foundations-theming-base/static-1.3226",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.718",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2948",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4157",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8437",
  "ai-rendering-library": "/ai-rendering-library/static-1.9398",
  "chirp-fetch": "/chirp-fetch/static-1.1713",
  "connections-embed-lib": "/connections-embed-lib/static-1.683",
  "copilot-toolkit": "/copilot-toolkit/static-1.10615",
  "laboratory-lib": "/laboratory-lib/static-3.6990",
  "marketplace-embed": "/marketplace-embed/static-1.21560",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8934",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18994",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13209",
  "sanitize-text": "/sanitize-text/static-1.7976",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8527",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5580",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4852",
  "wootric-nps": "/wootric-nps/static-1.6815",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4482",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3985",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66656",
  "cssUtils": "/cssUtils/static-1.744",
  "flux-actions": "/flux-actions/static-1.311",
  "HubStyle": "/HubStyle/static-2.11579",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10042",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10204",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7156",
  "icons": "/icons/static-2.625",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17571",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4351",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "quartz-i18n": "/quartz-i18n/static-1.449",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3562",
  "customer-data-objects": "/customer-data-objects/static-1.7479",
  "property-translator": "/property-translator/static-1.5240",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7755",
  "hs-promise-utils": "/hs-promise-utils/static-1.5424",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4711",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12946",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5419",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7619",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4305",
  "superstore": "/superstore/static-1.4602",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9977",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7548",
  "hub-http-janus": "/hub-http-janus/static-1.803",
  "hubspotter-http": "/hubspotter-http/static-1.4508",
  "immutable-less": "/immutable-less/static-1.4485",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16445",
  "nav-meta": "/nav-meta/static-1.29016",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10069",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17700",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3704",
  "property-management-common": "/property-management-common/static-1.4750",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8877",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.491",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.449",
  "quartz-head": "/quartz-head/static-1.439",
  "quartz-test": "/quartz-test/static-1.449",
  "quartz-tracking": "/quartz-tracking/static-1.153",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2970",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20467",
  "ContentUtils": "/ContentUtils/static-1.67714",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2320",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39018",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12841",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12977",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13656",
  "ExportDialog": "/ExportDialog/static-6.10218",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40736",
  "reporting-snowflake": "/reporting-snowflake/static-1.55274",
  "reporting-ui-components": "/reporting-ui-components/static-2.63927",
  "reporting-visualizations": "/reporting-visualizations/static-1.58732",
  "ui-addon-teams": "/ui-addon-teams/static-1.21281",
  "magpie-lib": "/magpie-lib/static-1.5425",
  "magpie-types": "/magpie-types/static-1.4885",
  "simple-logging-lib": "/simple-logging-lib/static-1.2881",
  "navigation-components": "/navigation-components/static-1.17379",
  "ai-studio-lib": "/ai-studio-lib/static-1.11086",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10323",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7822",
  "ui-tool-access": "/ui-tool-access/static-1.9976",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8095",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5583",
  "usage-tracker-public": "/usage-tracker-public/static-1.6977",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3450",
  "persist-promise": "/persist-promise/static-1.3539",
  "reference-resolvers": "/reference-resolvers/static-1.7993",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3775",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.170",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2830",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2273",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "atom": "/atom/static-1.4901",
  "purchase-motions-components": "/purchase-motions-components/static-1.5521",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1382",
  "crm-component-utils": "/crm-component-utils/static-1.38557",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5703",
  "customer-data-properties": "/customer-data-properties/static-1.50862",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6703",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7923",
  "navigation-messaging": "/navigation-messaging/static-1.6706",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9549",
  "cms-field-types": "/cms-field-types/static-1.4638",
  "content-icons-ui": "/content-icons-ui/static-1.2167",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7079",
  "crm-message-bus": "/crm-message-bus/static-1.42463",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21453",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9654",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4557",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3863",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6608",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.804",
  "onboarding-tours": "/onboarding-tours/static-1.16306",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13156",
  "academy-common-lib": "/academy-common-lib/static-1.13116",
  "content-assistance-lib": "/content-assistance-lib/static-1.7494",
  "dashboard-lib": "/dashboard-lib/static-1.80758",
  "file-manager-components": "/file-manager-components/static-1.22992",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17976",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17693",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17685",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19525",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8524",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4597",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10748",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8860",
  "user-context": "/user-context/static-1.4930",
  "growth-payments-core": "/growth-payments-core/static-1.24822",
  "reporting-plugins": "/reporting-plugins/static-1.10022",
  "reporting-reports": "/reporting-reports/static-1.66334",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.556",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28926",
  "react-codemirror": "/react-codemirror/static-1.10457",
  "apps-service-types": "/apps-service-types/static-1.3708",
  "oauth-service-types": "/oauth-service-types/static-1.4077",
  "onboarding-scopes": "/onboarding-scopes/static-1.6294",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4520",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7521",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14621",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3473",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8665",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
  "nav-client-types": "/nav-client-types/static-1.2188",
  "purchase-motions-api": "/purchase-motions-api/static-1.5524",
  "signup-constants": "/signup-constants/static-1.18486",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7865",
  "trials-service-types": "/trials-service-types/static-1.3730",
  "card-properties-lib": "/card-properties-lib/static-1.43618",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36549",
  "crm-actions": "/crm-actions/static-1.6136",
  "crm-cards-data": "/crm-cards-data/static-1.1283",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43019",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8878",
  "customer-data-tracking": "/customer-data-tracking/static-1.6713",
  "calling-global-api": "/calling-global-api/static-1.63791",
  "calling-internal-common": "/calling-internal-common/static-1.31126",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65173",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57467",
  "commerce-products-lib": "/commerce-products-lib/static-1.8946",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3653",
  "crm-links": "/crm-links/static-1.6097",
  "external-options-client-types": "/external-options-client-types/static-1.4014",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.511",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4078",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.463",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3546",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48108",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3819",
  "property-value-citations": "/property-value-citations/static-1.1476",
  "pulse": "/pulse/static-1.347",
  "smart-property-lib": "/smart-property-lib/static-1.6058",
  "tiered-pricing": "/tiered-pricing/static-1.873",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10825",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3995",
  "react-dnd-compat": "/react-dnd-compat/static-1.4451",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5189",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2903",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1380",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.372",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7358",
  "academy-service-client": "/academy-service-client/static-1.3510",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28032",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8216",
  "video-components-external": "/video-components-external/static-1.10668",
  "video-data-lib": "/video-data-lib/static-1.34326",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8398",
  "payment-link-components": "/payment-link-components/static-1.23028",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9718",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23979",
  "viral-links-lib": "/viral-links-lib/static-1.6868",
  "data-token-picker": "/data-token-picker/static-1.16098",
  "FileManagerLib": "/FileManagerLib/static-1.38632",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5075",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17094",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8381",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.223",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
  "crm_data": "/crm_data/static-4.91347",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45504",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15176",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18585",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18032",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9876",
  "crm-fe-perf": "/crm-fe-perf/static-1.22736",
  "calling-error-reporting": "/calling-error-reporting/static-1.31132",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10870",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6372",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.341",
  "commerce-permissions": "/commerce-permissions/static-1.590",
  "products-iframe-lib": "/products-iframe-lib/static-1.7417",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9933",
  "directed-graph": "/directed-graph/static-1.770",
  "event-emitter": "/event-emitter/static-1.778",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5368",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9634",
  "policy-lib": "/policy-lib/static-1.6607",
  "react-tinymce": "/react-tinymce/static-1.54710",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9697",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53836",
  "tinymce-plugins": "/tinymce-plugins/static-1.56950",
  "tinymce-themes": "/tinymce-themes/static-1.55806",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1408",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6413",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11570",
  "content-media-compositions": "/content-media-compositions/static-2.15577",
  "media-bridge-lib": "/media-bridge-lib/static-1.18620",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5763",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4917",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3498",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21361",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3674",
  "audio-components": "/audio-components/static-1.5658",
  "FileManagerCore": "/FileManagerCore/static-1.38491",
  "FileManagerImages": "/FileManagerImages/static-1.36143",
  "video-components": "/video-components/static-1.12671",
  "crm_universal": "/crm_universal/static-1.21715",
  "customer-data-email": "/customer-data-email/static-1.17724",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36602",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38972",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11316",
  "customer-data-content": "/customer-data-content/static-1.26928",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54133",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20948",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17230",
  "project-storage": "/project-storage/static-1.4564",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71312",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5160",
  "utility-belt": "/utility-belt/static-1.2371",
  "customer-data-associations": "/customer-data-associations/static-1.7169",
  "framework-data-table": "/framework-data-table/static-2.11490",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22113",
  "customer-data-rte": "/customer-data-rte/static-1.32522",
  "cv-backend-services": "/cv-backend-services/static-1.1514",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5413",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14307",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4945",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37401",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35118",
  "sales-views-client-types": "/sales-views-client-types/static-1.4117",
  "hub-http-contrib": "/hub-http-contrib/static-1.2874",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39921",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5045",
  "layout-dnd-components": "/layout-dnd-components/static-1.12095",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11070",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14092",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8926",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4362",
  "video-embed": "/video-embed/static-1.35160",
  "social-insights-client-types": "/social-insights-client-types/static-1.21453",
  "sequences-lib": "/sequences-lib/static-1.7737",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10178",
  "products-ui-components": "/products-ui-components/static-1.39465",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80032",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8945",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6775",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54149",
  "commerce-products-api": "/commerce-products-api/static-1.1999",
  "SafeStorage": "/SafeStorage/static-1.4234",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56207",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101989",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1373",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7188",
  "draft-content-plugins": "/draft-content-plugins/static-1.27789",
  "ContentData": "/ContentData/static-1.67789",
  "layout-data-lib": "/layout-data-lib/static-1.9395",
  "outpost": "/outpost/static-1.4033",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7594",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.347",
  "property-description-translator": "/property-description-translator/static-1.3686",
  "FireAlarmUi": "/FireAlarmUi/static-1.4362",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4022",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3486",
  "totals-ui-components": "/totals-ui-components/static-1.23078",
  "deal-intel-utils": "/deal-intel-utils/static-1.1377",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14863",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11834",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33539",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3670",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14862",
  "simple-menus-lib": "/simple-menus-lib/static-1.16379"
}
};
